<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <order-menu :menuType="2" />
        <div class="integral_con">
          <div class="collec_title"><i>我的积分：</i><em>{{userInfo.integral}}</em></div>
          <div class="side">
            <div class="collec_state">
              <div class="info_row">积分信息</div>
              <div class="info_time">日期</div>
              <div class="ctrl_row">积分变化</div>
            </div>
            <ul
              class="collec_item"
              v-for="(item, index) in integralList"
              :key="index"
            >
              <li class="row1">
                <!-- <div class="collec_img">afsdf</div> -->
                <div class="item_title">
                  <i>{{item.detail}}</i>
                  <!-- <em>订单号：2021083100011174</em> -->
                </div>
              </li>
              <li class="row3">
                <div>{{ item.addTime }}</div>
              </li>
              <li class="row2">
                <div>+{{ item.score }}</div>
              </li>
            </ul>
          </div>
          <div class="integral_page">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :page-count="pageCount"
              @current-change="currentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { posts } from '../../utils/posts'
import crumb from '../../components/bread-crumb/Index.vue'
import orderMenu from '../../components/order_menu.vue'

export default {
  name: '我的积分',
  components: {
    crumb,
    orderMenu
  },
  setup () {
    const store = useStore()
    const userInfo = store.state.userInfo
    const integralList = ref([])
    const page = ref(1) // 默认页数
    const pageSize = ref(16) // 默认每页数量
    const pageCount = ref(1) // 总页数
    const totalCount = ref(0)
    // 获取分页数量
    const currentChange = (e) => {
      page.value = e
      integralHandle()
    }
    const integralHandle = () => {
      posts('users/integralList/' + userInfo.uid, { page: page.value }).then(
        (res) => {
          integralList.value = res.data
          pageCount.value = res.pageCount
        }
      )
    }

    onMounted(() => {
      integralHandle()
    })
    return {
      currentChange,
      integralHandle,
      totalCount,
      pageSize,
      pageCount,
      page,
      userInfo,
      integralList
    }
  }
}
</script>
<style lang="scss">
.container {
  width: 1200px;
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 50px 0;
  .integral_con {
    width: 880px;
    background: white;
    .integral_page {
      padding: 20px 30px;
      display: flex;
      justify-content: flex-end;
    }
    .side {
      margin: 30px 30px 0 30px;
      padding: 0 0 20px 0;
      border: 1px solid #eeeeee;
      height: 630px;
      .collec_item {
        padding: 20px 20px 0 20px;
        display: flex;
        justify-content: space-between;
        .row3 {
          flex: 2;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .row2 {
          flex: 1;
          padding: 0 0 0 12px;
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          div {
            font-size: 20px;
            font-weight: bold;
            color: #fc4353;
          }
        }
        .row1 {
          flex: 3;
          display: flex;
          align-items: baseline;
          padding: 0 12px 0 0;
          .item_title {
            display: flex;
            flex-direction: column;
            em {
              font-size: 14px;
              font-weight: 400;
              line-height: 28px;
              color: #999999;
            }
            i {
              font-size: 14px;
              font-weight: 400;
              line-height: 22px;
              color: #3e3a39;
            }
          }
          .collec_img {
            width: 80px;
            height: 80px;
            overflow: hidden;
            margin: 0 12px 0 0;
            flex-shrink: 0;
            background: chocolate;
          }
        }
      }
      .collec_state {
        padding: 14px 20px;
        background: #f5f5f5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #3e3a39;
        .info_time {
          flex: 2;
          text-align: center;
        }
        .info_row {
          flex: 3;
        }
        .ctrl_row {
          flex: 1;
          text-align: center;
        }
      }
    }
    .collec_title {
      height: 48px;
      padding: 12px 20px;
      font-size: 18px;
      font-weight: 600;
      color: #3e3a39;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      em {
        color: #fc4353;
      }
    }
  }
}
</style>
